import { useEffect, useState } from 'react';
import { Button, Modal, Space, Spin, Table, message } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { ExclamationCircleFilled } from '@ant-design/icons';
import SignTypeModal from './signTypeModal';
import {
  deleteSignTypeApi,
  getSignTypeListApi,
  updateSignTypeStatusApi,
} from '@/services/signAndPayment';
import './index.less';

const { confirm } = Modal;

interface DataType {
  type: string;
  name: string;
  domain: string;
  url: string;
  status: boolean;
  createdAt?: string;
}

const SignTypeList = () => {
  const [loading, setLoading] = useState(true);
  const [editType, setEditType] = useState<number>(0);
  const [signTypeList, setSignTypeList] = useState<DataType[]>([]);
  const [editVisible, setEditVisible] = useState(false);
  const [selectedSignType, setSelectedSignType] = useState({});

  const getSignTypeList = async () => {
    const res = await getSignTypeListApi();
    if (res.data && res.data.code === 'SUCCESS' && res.code === 200) {
      setSignTypeList(res.data.details);
    }
    setLoading(false);
  };

  useEffect(() => {
    getSignTypeList();
  }, []);

  // 更新签约平台状态
  const updateSignTypeStatus = async (type: string, status: number) => {
    const res = await updateSignTypeStatusApi(type, status);
    if (res.data && res.data.code === 'SUCCESS' && res.code === 200) {
      message.info(status === 1 ? '启用成功' : '禁用成功');
      getSignTypeList();
    }
  };

  const updateSignStatus = (record: DataType) => {
    if (!record.status) {
      // 启用签约平台
      updateSignTypeStatus(record.type, 1);
    } else {
      confirm({
        icon: <ExclamationCircleFilled />,
        title: `确定要禁用【${record.name}】签约平台?`,
        content: '禁用后客户将没法使用该平台进行合同签约',
        okText: '确定',
        onOk: () => {
          // 禁用签约平台
          updateSignTypeStatus(record.type, 0);
        },
      });
    }
  };

  const editSignType = (type: number, record?: any) => {
    setEditType(type);
    setSelectedSignType(record);
    setEditVisible(true);
  };

  const handleCancel = () => {
    setEditVisible(false);
    getSignTypeList();
  };

  const deleteSignType = async (record: any) => {
    confirm({
      icon: <ExclamationCircleFilled />,
      title: `确定要删除【${record.name}】签约平台?`,
      okText: '确定',
      onOk: async () => {
        const res = await deleteSignTypeApi(record.type);
        if (res.data && res.data.code === 'SUCCESS' && res.code === 200) {
          message.info('删除成功');
          getSignTypeList();
        }
      },
    });
  };

  const columns: ColumnsType<DataType> = [
    {
      title: '签约平台名称',
      dataIndex: 'name',
      key: 'name',
      width: 150,
      render: (text) => <span>{text}</span>,
    },
    {
      title: '签约平台标识',
      dataIndex: 'type',
      key: 'type',
      width: 150,
      render: (text) => <span>{text}</span>,
    },
    {
      title: '签约平台接口域名',
      dataIndex: 'domain',
      key: 'domain',
      width: 250,
      render: (text) => <span>{text}</span>,
    },
    {
      title: '签约平台官方地址',
      dataIndex: 'url',
      key: 'url',
      width: 250,
      render: (text) => (text ? <a href={text}>{text}</a> : <span>{text}</span>),
    },
    {
      title: '启用状态',
      dataIndex: 'status',
      key: 'status',
      width: 150,
      render: (text) => (
        <span className={text ? 'statusEnabled' : 'statusDisabled'}>{text ? '启用' : '禁用'}</span>
      ),
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <div
            className="actionBtn"
            style={{ color: record.status ? 'red' : '' }}
            onClick={() => updateSignStatus(record)}
          >
            {record.status ? '禁用' : '启用'}
          </div>
          <div className="actionBtn" onClick={() => editSignType(1, record)}>
            编辑
          </div>
          <div
            className="actionBtn"
            style={{ color: 'red' }}
            onClick={() => deleteSignType(record)}
          >
            删除
          </div>
        </Space>
      ),
    },
  ];

  return (
    <div className="signTypeBody">
      <div className="signTypeHead">
        <Button type="primary" onClick={() => editSignType(0, {})}>
          新增
        </Button>
      </div>
      <Spin spinning={loading}>
        <div className="signTypeContent">
          <Table
            columns={columns}
            dataSource={signTypeList}
            rowKey={(record: any) => record.type}
            pagination={false}
            scroll={{ x: true, y: 'calc(100vh - 340px)' }}
          />
        </div>
      </Spin>
      {editVisible && (
        <SignTypeModal
          data={selectedSignType}
          visible={editVisible}
          editType={editType}
          handleCancel={handleCancel}
        />
      )}
    </div>
  );
};
export default SignTypeList;
